/**
 * This class is used in the image cropper to load the source and selection image and render it based on the
 * scale, and position of the image being loaded. This is used from the detailed-cropper.js file.
 */
import React from 'react'
import ReactDOM from 'react-dom'
import OpeLoader from '../../utils/ope-loader'
import ImageStore from '../../../stores/image-store'
import ProductStore from '../../../stores/product-store'
import createReactClass from 'create-react-class'
const Hammer = require('hammerjs')

var	_activeImageFilter = '';
var	_loadingImage = false;

var CropperImageContainer = createReactClass({
    mounted: false,

	getInitialState: function() {
		return {
			imageSource: null,
			touchInteractionsLoaded: false
		}
	},

	componentWillUpdate: function() {
		if(JSON.stringify(this.props.item.options.imageFilter) !== _activeImageFilter && this.state.imageSource !== null) {
			_loadingImage = true;
		}
		var item = this.props.item;
	},

	componentDidUpdate: function() {
		if(JSON.stringify(this.props.item.options.imageFilter) !== _activeImageFilter) {
			this._getImage();
		}
		// Return the selectionImage to the cropper
		this.props.selectionImageCallback(document.getElementById('cropper-image'));

		if (this.state.imageSource !== null && !this.state.touchInteractionsLoaded) {
			this.addTouchInteractionEvents();
		}
	},

	componentWillMount: function() {
		var item = this.props.item;
	},

	addTouchInteractionEvents: function () {
		var instance = this,
			pinch, rotate;
		try {
			pinch = new Hammer.Pinch();
			rotate = new Hammer.Rotate();
			// Add listeners for the component
			var mc = new Hammer(ReactDOM.findDOMNode(instance));
			mc.get('pan').set({threshold: 0 });
			mc.add([pinch, rotate]);
			mc.on('panstart panmove panend pinchin pinchout pinchstart pinchend doubletap tap rotatemove rotateend', function(event) {
				instance.props.touchInteractionCallback(event, instance);
			});

			this.setState({touchInteractionsLoaded: true});

		} catch(err) {
			console.error(err);
		}
	},
	componentDidMount: function() {
        this.mounted = true;
		this._getImage();
		if(typeof this.props.item.options.imageFilter !== 'undefined') {
			_activeImageFilter = JSON.stringify(this.props.item.options.imageFilter);
		}
	},

	_getImage: function() {
		var instance = this,
			imageContainer = document.getElementById('ope-cropper__selection'),
			requiredImageSize,
			pixelRatio = 1;

		if(window.devicePixelRatio) {
			pixelRatio = window.devicePixelRatio;
		}
		this.props.imageLoadingCallback();
		// Get a version of the image 1.5 times larger than what is needed for the container * scale
		requiredImageSize = Math.floor(((imageContainer.offsetWidth * this.props.item.options.scale) * 1.5) * pixelRatio);

		ImageStore.getImageById(instance.props.item.getImageId()).getSrcWithFilter(requiredImageSize, instance.props.item.getImageFilters()).then (
			function (src) {
				// If the call was made and not returned before the cropper was closed by the user, do not update state as there will be
				// no component to react to the state change
				if (instance.mounted) {
					instance.setState({imageSource: src} );
					_loadingImage = false;
					_activeImageFilter = JSON.stringify(instance.props.item.options.imageFilter);
					instance.props.imageLoadingCallback();
				}
			})['catch'](function (err) {
				_loadingImage = false;
				displayError("Cannot show photo. Please try deleting and uploading it again. If it still doesn’t show, please contact us.", {imageId: instance.props.item.getImageId(), error: err});
		});
	},

	render: function() {
		var image = this.props.item,
			options = this.props.options,
			settings = this.props.settings,
			applyingFilter = false,
			imageYAdjust = settings.fillerSize.height > 0 ? (settings.fillerSize.width - settings.selectionSettings.width) / 2 : 0,
			transformStr = 'translate3d(' + 100 * options.position.percentageX + '%, ' + 100 * options.position.percentageY + '%, 0px)' +
							'scale(' + options.scale + ')',
			componentStyle = {
				transform: transformStr,
				WebkitTransform: transformStr,
				width: this.props.imageSize.width,
				height: this.props.imageSize.height
			},
			selectionStyle = {
				width: settings.selectionSettings.width,
				height: settings.selectionSettings.height,
				left: settings.selectionSettings.x,
				top: settings.selectionSettings.y + imageYAdjust
			};

		if(this.state.imageSource && _loadingImage) {
			applyingFilter = true;
		}

		return (
			<div>
				<div className="" id={this.props.elementId} style={selectionStyle} >
					{this.state.imageSource ?
						<img src={this.state.imageSource} style={componentStyle} id="cropper-image"/>
						: <OpeLoader /> }
					{ applyingFilter ?
						<OpeLoader /> : null
					}

					{ this.props.children }
				</div>
			</div>
		);
	},
    componentWillUnmount: function() {
        this.mounted = false;
    }
});

export default CropperImageContainer;
